export class DataStoreOptions {
  public getLastest = false;
  public storeInClient = true;
}
